<template>
  <v-content class="pa-12">
    <v-layout style="background-color: #faf5f2">
      <v-flex>
        <v-flex shrink style="text-align: right"
          ><v-btn
            @click="printPage()"
            dark
            style="width: 80px; background-color: black"
            ><v-icon>local_printshop</v-icon></v-btn
          ></v-flex
        >
        <!-- Nevigater -->
        <v-layout mb-12 v-if="$route.query.name === 'verify-rf'">
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            class="nevigater-link"
            @click="$router.go(-1)"
          >
            <span>ตรวจสอบแบบฟอร์ม RF</span>
          </v-flex>
          <v-flex shrink d-flex justify-start align-center>
            <v-icon color="#3E7662">arrow_right</v-icon>
          </v-flex>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            style="color: #3e7662; font-weight: bold; font-size: 24px"
          >
            <span>แจ้งปิดโครงการวิจัยก่อนกำหนด</span>
          </v-flex>
        </v-layout>
        <v-layout v-else mb-12>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            class="nevigater-link"
            @click="$router.go(-1)"
          >
            <span>Post Approve</span>
          </v-flex>
          <v-flex shrink d-flex justify-start align-center>
            <v-icon color="#3E7662">arrow_right</v-icon>
          </v-flex>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            style="color: #3e7662; font-weight: bold; font-size: 24px"
          >
            <span>แจ้งปิดโครงการวิจัยก่อนกำหนด</span>
          </v-flex>
        </v-layout>
        <div id="print" style="height: auto">
          <div class="print-form">
            <v-layout>
              <v-flex>
                <v-layout mt-3 style="background-color: #3e7662">
                  <v-flex
                    my-8
                    ml-8
                    style="
                      text-align: left;
                      font-weight: bold;
                      font-size: 28px;
                      color: white;
                    "
                  >
                    <div>รายงานการยุติโครงการวิจัยก่อนกำหนด</div>
                    <div style="font-size: 18px">
                      Study Termination Memorandum
                    </div>
                  </v-flex>
                  <v-flex
                    ml-8
                    pt-8
                    pr-8
                    style="
                      text-align: right;
                      font-weight: bold;
                      font-size: 13px;
                      color: white;
                    "
                  >
                    <span>RF 06_2563</span>
                  </v-flex>
                </v-layout>

                <!-- blog 1 -->
                <v-card class="mb-12 px-12">
                  <v-layout py-12>
                    <v-flex>
                      <v-layout justify-center>
                        <v-flex
                          xs2
                          mr-4
                          pt-2
                          style="text-align: right; font-weight: bold"
                        >
                          <span>ชื่อโครงการวิจัย</span>
                        </v-flex>
                        <v-flex xs6>
                          <textarea-form
                            :model="form.researchName"
                            style="font-weight: bold"
                            readonly
                          ></textarea-form>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center>
                        <v-flex
                          xs2
                          mr-4
                          pt-2
                          style="text-align: right; font-weight: bold"
                        >
                          <span>รหัสโครงการวิจัย</span>
                        </v-flex>
                        <v-flex xs6>
                          <textfield-form
                            :model="form.researchCode"
                            style="font-weight: bold"
                            readonly
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center>
                        <v-flex
                          xs2
                          mr-4
                          pt-2
                          style="text-align: right; font-weight: bold"
                        >
                          <span>ผู้สนับสนุนทุนวิจัย</span>
                        </v-flex>
                        <v-flex xs6>
                          <textfield-form
                            :model="form.researchInvestor"
                            style="font-weight: bold"
                            readonly
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center>
                        <v-flex
                          xs2
                          mr-4
                          pt-2
                          style="text-align: right; font-weight: bold"
                        >
                          <span>ผู้วิจัยหลัก</span>
                        </v-flex>
                        <v-flex xs6>
                          <textfield-form
                            :model="form.mainResearcher"
                            style="font-weight: bold"
                            readonly
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center>
                        <v-flex
                          xs2
                          mr-4
                          pt-2
                          style="text-align: right; font-weight: bold"
                        >
                          <span>โทรศัพท์</span>
                        </v-flex>
                        <v-flex xs6>
                          <textfield-form
                            :model="form.phoneNumber"
                            style="font-weight: bold"
                            readonly
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center>
                        <v-flex
                          xs2
                          mr-4
                          pt-2
                          style="text-align: right; font-weight: bold"
                        >
                          <span>อีเมล์</span>
                        </v-flex>
                        <v-flex xs6>
                          <textfield-form
                            :model="form.email"
                            style="font-weight: bold"
                            readonly
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>

                <!-- blog 2 -->
                <v-layout
                  pt-12
                  pb-8
                  mb-12
                  style="
                    background-color: white;
                    padding-left: 100px;
                    padding-right: 100px;
                  "
                >
                  <v-flex>
                    <!-- row 1 -->
                    <v-layout>
                      <v-flex
                        xs3
                        pt-2
                        mr-3
                        style="text-align: right; font-weight: bold"
                      >
                        <span>วันที่รับรองโครงร่างการวิจัยครั้งแรก</span>
                      </v-flex>
                      <v-flex xs3>
                        <v-layout>
                          <v-flex>
                            <textfield-form
                              readonly
                              :model="dateChange.firstDate"
                            ></textfield-form>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex
                        xs3
                        pt-2
                        mr-3
                        style="text-align: right; font-weight: bold"
                      >
                        <span>วันที่รับรองโครงร่างการวิจัยครั้งล่าสุด</span>
                      </v-flex>
                      <v-flex xs3>
                        <v-layout>
                          <v-flex>
                            <textfield-form
                              readonly
                              :model="dateChange.lastDate"
                            ></textfield-form>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>

                    <!-- row 2 -->
                    <v-layout>
                      <v-flex
                        xs3
                        pt-2
                        mr-3
                        style="text-align: right; font-weight: bold"
                      >
                        <span>วันที่เริ่มดำเนินการวิจัย</span>
                      </v-flex>
                      <v-flex xs3>
                        <v-layout>
                          <v-flex>
                            <textfield-form
                              readonly
                              :model="dateChange.startDate"
                            ></textfield-form>
                            <v-checkbox
                              v-model="form.hasStartDate"
                              v-bind:true-value="true"
                              v-bind:false-value="false"
                              color="#3E7662"
                              style="margin-left: 10px; margin-top: 4px;"
                              label="ยังไม่ได้เริ่มเก็บข้อมูล"
                            ></v-checkbox>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex
                        xs3
                        pt-2
                        mr-3
                        style="text-align: right; font-weight: bold"
                      >
                        <span>วันที่สิ้นสุดการวิจัย</span>
                      </v-flex>
                      <v-flex xs3>
                        <v-layout>
                          <v-flex>
                            <textfield-form
                              readonly
                              :model="dateChange.endDate"
                            ></textfield-form>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <!-- blog 3 -->
                <v-layout
                  pt-12
                  pb-8
                  mb-12
                  style="
                    background-color: white;
                    padding-left: 100px;
                    padding-right: 100px;
                  "
                >
                  <v-flex>
                    <!-- Group 1 -->
                    <v-layout pt-4>
                      <v-flex d-flex justify-start>
                        <span style="font-weight: bold; font-size: 18px"
                          >Summary of Protocol Participants</span
                        >
                      </v-flex>
                    </v-layout>
                    <v-layout py-6 pl-12>
                      <v-flex>
                        <v-layout pt-1>
                          <v-flex d-flex justify-start>
                            <v-layout>
                              <v-flex class="d-flex align-center xs6">
                                <span style="color: #3e7662"
                                  >Accrual ceiling set by IEC/IRB</span
                                >
                              </v-flex>
                              <v-flex class="xs3">
                                <textfield-form
                                  hide-detail
                                  :model="form.accrualCeiling"
                                  style="font-weight: bold"
                                  readonly
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout pt-1>
                          <v-flex d-flex justify-start>
                            <v-layout>
                              <v-flex class="d-flex align-center xs6">
                                <span style="color: #3e7662"
                                  >Total accrued participants</span
                                >
                              </v-flex>
                              <v-flex class="xs3">
                                <textfield-form
                                  hide-detail
                                  :model="form.totalParticipants"
                                  style="font-weight: bold"
                                  readonly
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout pt-1>
                          <v-flex d-flex justify-start>
                            <v-layout>
                              <v-flex class="d-flex align-center xs6">
                                <span style="color: #3e7662"
                                  >Total participants fail screening</span
                                >
                              </v-flex>
                              <v-flex class="xs3">
                                <textfield-form
                                  hide-detail
                                  :model="form.totalScreening"
                                  style="font-weight: bold"
                                  readonly
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout pt-1>
                          <v-flex d-flex justify-start>
                            <v-layout>
                              <v-flex class="d-flex align-center xs6">
                                <span style="color: #3e7662"
                                  >Total participants withdrawn</span
                                >
                              </v-flex>
                              <v-flex class="xs3">
                                <textfield-form
                                  hide-detail
                                  :model="form.totalWithdrawn"
                                  style="font-weight: bold"
                                  readonly
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout pt-1>
                          <v-flex d-flex justify-start>
                            <v-layout>
                              <v-flex class="d-flex align-center xs6">
                                <span style="color: #3e7662"
                                  >Total participants dead</span
                                >
                              </v-flex>
                              <v-flex class="xs3">
                                <textfield-form
                                  hide-detail
                                  :model="form.totalDead"
                                  style="font-weight: bold"
                                  readonly
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout pt-1>
                          <v-flex d-flex justify-start>
                            <v-layout>
                              <v-flex class="d-flex align-center xs6">
                                <span style="color: #3e7662"
                                  >Total participants complete the
                                  research</span
                                >
                              </v-flex>
                              <v-flex class="xs3">
                                <textfield-form
                                  hide-detail
                                  :model="form.totalCompleteResearch"
                                  style="font-weight: bold"
                                  readonly
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <!-- Group 2 -->
                    <v-layout pt-8>
                      <v-flex d-flex justify-start>
                        <span style="font-weight: bold; font-size: 18px"
                          >Summary of Protocol Participants</span
                        >
                      </v-flex>
                    </v-layout>
                    <v-layout pt-6 pb-12 pl-12>
                      <v-flex>
                        <v-layout pt-1>
                          <v-flex d-flex justify-start>
                            <v-layout>
                              <v-flex class="d-flex align-center xs6">
                                <span style="color: #3e7662"
                                  >Total participants experience adverse
                                  events</span
                                >
                              </v-flex>
                              <v-flex class="xs3">
                                <textfield-form
                                  hide-detail
                                  :model="form.totalExpAdversEvents"
                                  style="font-weight: bold"
                                  readonly
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout pt-1>
                          <v-flex d-flex justify-start>
                            <v-layout>
                              <v-flex class="d-flex align-center xs6">
                                <span style="color: #3e7662"
                                  >Total participants experience SUSARs</span
                                >
                              </v-flex>
                              <v-flex class="xs3">
                                <textfield-form
                                  hide-detail
                                  :model="form.totalExpSUSARs"
                                  style="font-weight: bold"
                                  readonly
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout pt-1>
                          <v-flex d-flex justify-start>
                            <v-layout>
                              <v-flex class="d-flex align-center xs6">
                                <span style="color: #3e7662"
                                  >Total global participants experience SUSARs,
                                  if applicable.</span
                                >
                              </v-flex>
                              <v-flex class="xs3">
                                <textfield-form
                                  hide-detail
                                  :model="form.totalGlobal"
                                  style="font-weight: bold"
                                  readonly
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <!-- Group 3 -->
                    <v-layout py-6>
                      <v-flex d-flex justify-start>
                        <span style="font-weight: bold; font-size: 18px">
                          Has there been any protocol deviation/violation or
                          compliance issues occurred during the study?
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-layout pl-12>
                      <v-flex style="color: #3e7662">
                        <v-radio-group readonly v-model="form.hasIssue" row>
                          <v-radio
                            color="#3E7662"
                            style="padding-right: 100px"
                            label="No"
                            value="0"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="YES (please attach a report)"
                            value="1"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                    <v-layout v-if="form.hasIssue === '1'">
                      <v-flex shrink>
                        <span
                          v-if="anyProtocolFile"
                          class="text-start linkPDF"
                          style="font-size: 16px; color: #cc3d45"
                          @click="open(anyProtocolFilePath)"
                        >
                          File: {{ anyProtocolFile }}
                        </span>
                        <span
                          v-else
                          class="text-start"
                          style="font-size: 12px; color: #cc3d45"
                        >
                          File: ไม่มี
                        </span>
                      </v-flex>
                    </v-layout>
                    <!-- Group 4 -->
                    <v-layout py-6>
                      <v-flex d-flex justify-start>
                        <span style="font-weight: bold; font-size: 18px">
                          Has there been any complaint or warning letter against
                          the research or investigator during the study?
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-layout pl-12>
                      <v-flex style="color: #3e7662">
                        <v-radio-group readonly v-model="form.hasWarning" row>
                          <v-radio
                            color="#3E7662"
                            style="padding-right: 100px"
                            label="No"
                            value="0"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="YES (please attach a report)"
                            value="1"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                    <v-layout v-if="form.hasWarning === '1'">
                      <v-flex shrink>
                        <span
                          v-if="anyComplaintFile"
                          class="text-start linkPDF"
                          style="font-size: 16px; color: #cc3d45"
                          @click="open(anyComplaintFilePath)"
                        >
                          File: {{ anyComplaintFile }}
                        </span>
                        <span
                          v-else
                          class="text-start"
                          style="font-size: 12px; color: #cc3d45"
                        >
                          File: ไม่มี
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <!-- blog 4 -->
                <v-layout
                  pt-12
                  pb-8
                  mb-12
                  style="
                    background-color: white;
                    padding-left: 100px;
                    padding-right: 100px;
                  "
                >
                  <v-flex>
                    <!-- row 1 -->
                    <v-layout mb-4>
                      <v-flex d-flex justify-start>
                        <span style="font-weight: bold; font-size: 18px">
                          Reasons for the premature study termination
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-layout pt-6 mb-12>
                      <v-flex d-flex justify-start>
                        <textarea-form
                          :model="form.reason"
                          readonly
                        ></textarea-form>
                      </v-flex>
                    </v-layout>

                    <!-- row 2 -->
                    <v-layout mb-4>
                      <v-flex d-flex justify-start>
                        <span style="font-weight: bold; font-size: 18px">
                          Are there any follow-up and management for
                          participants after study termination
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-layout pl-12>
                      <v-flex style="color: #3e7662">
                        <v-radio-group readonly v-model="form.hasFollowUp" row>
                          <v-radio
                            color="#3E7662"
                            style="padding-right: 100px"
                            label="No"
                            value="0"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="YES (Please describe)"
                            value="1"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex d-flex justify-start>
                        <textarea-form
                          :model="form.followUp"
                          readonly
                        ></textarea-form>
                      </v-flex>
                    </v-layout>

                    <!-- row 3 -->
                    <v-layout mb-4>
                      <v-flex d-flex justify-start>
                        <span style="font-weight: bold; font-size: 18px">
                          Is there any plan to inform participants
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-layout pl-12>
                      <v-flex style="color: #3e7662">
                        <v-radio-group readonly v-model="form.hasPlan" row>
                          <v-radio
                            color="#3E7662"
                            style="padding-right: 100px"
                            label="No"
                            value="0"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="YES (Please describe)"
                            value="1"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex d-flex justify-start>
                        <textarea-form
                          :model="form.plan"
                          readonly
                        ></textarea-form>
                      </v-flex>
                    </v-layout>

                    <!-- row 4 -->
                    <v-layout mt-12 mb-4>
                      <v-flex xs6 style="text-align: left">
                        <span style="font-weight: bold; font-size: 18px">
                          Attach a summary of result
                        </span>
                      </v-flex>
                    </v-layout>
                    <div v-if="showResultFile" class="mt-1 text-start">
                      <b>ไฟล์ที่อัพโหลด: </b>
                      <span
                        class="linkPDF"
                        style="font-size: 16px; color: #cc3d45"
                        @click="open('pathLink')"
                        >{{ showResultFile }}</span
                      >
                    </div>

                    <v-layout class="my-12">
                      <v-flex>
                        <v-layout class="mb-8">
                          <v-flex>
                            <v-layout>
                              <v-flex shrink pr-4 style="text-align: left">
                                <span style="font-weight: bold; font-size: 16px"
                                  >หนังสือของหน่วยงาน :
                                </span>
                              </v-flex>
                              <v-flex shrink>
                                <span
                                  v-if="agencyBook"
                                  class="text-start linkPDF"
                                  style="font-size: 16px; color: #cc3d45"
                                  @click="open('agencyBookLink')"
                                >
                                  {{ agencyBook }}
                                </span>
                                <span
                                  v-else
                                  class="text-start"
                                  style="font-size: 12px; color: #cc3d45"
                                >
                                  -
                                </span>
                              </v-flex>
                              <v-spacer></v-spacer>
                            </v-layout>
                          </v-flex>
                        </v-layout>

                        <v-layout>
                          <v-flex xs6>
                            <v-layout>
                              <v-flex
                                class="d-flex align-center mr-4 font-weight-bold"
                                shrink
                                >เลขหนังสือ</v-flex
                              >
                              <v-flex>
                                <textfield-form
                                  readonly
                                  hide-detail
                                  :model="form.bookNumber"
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex xs6>
                            <v-layout>
                              <v-flex
                                class="d-flex align-center mx-4 font-weight-bold"
                                shrink
                                >วันที่หนังสือ</v-flex
                              >
                              <v-flex>
                                <textfield-form
                                  hide-detail
                                  readonly
                                  :model="form.bookDate"
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex xs6 mt-5>
                            <v-layout>
                              <v-flex
                                class="d-flex align-center mr-4 font-weight-bold"
                                shrink
                                >หน่วยงานที่ออกหนังสือ</v-flex
                              >
                              <v-flex>
                                <textfield-form
                                  hide-detail
                                  :model="form.instituteBook"
                                  @update-data="
                                    updateData('instituteBook', $event)
                                  "
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                            <div
                              v-for="(input, k) in form.fileOther"
                              :key="'d' + k"
                              class="my-5"
                            >
                              <v-layout>
                                <v-flex>
                                  <v-layout>
                                    <v-flex
                                      shrink
                                      mr-4
                                      pt-2
                                      style="text-align: right;font-weight: bold;"
                                    >
                                      <span>ชื่อไฟล์</span>
                                    </v-flex>
                                    <v-flex xs2>
                                      <textfield-form
                                        hide-detail
                                        :model="input.title"
                                      ></textfield-form>
                                    </v-flex>
                                    <v-flex v-if="input.filePath"
                                      ><a
                                        :href="input.filePath"
                                        target="_blank"
                                        style="color: #3e7662;text-align: center"
                                        class="link-hover"
                                      >
                                        <p>ไฟล์ที่อัพโหลด: {{ input.file }}</p>
                                      </a>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-layout> </v-layout>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>

                    <!-- row 4 -->
                    <v-layout mt-12>
                      <v-flex xs6 pl-3 mr-6>
                        <v-text-field
                          readonly
                          dense
                          placeholder="signature"
                          append-icon="edit"
                          color="#3E7662"
                          v-model="form.signature"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs3>
                        <!--                                        <DateInputForm-->
                        <!--                                                style="font-weight: bold"-->
                        <!--                                                label="Date"-->
                        <!--                                                :model="dateChange.reportDate"-->
                        <!--                                                readonly-->
                        <!--                                        ></DateInputForm>-->
                        <v-layout>
                          <v-flex
                            class="d-flex align-center mx-4 font-weight-bold"
                            shrink
                            >Date</v-flex
                          >
                          <v-flex>
                            <textfield-form
                              hide-detail
                              readonly
                              :model="dateChange.reportDate"
                            ></textfield-form>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout style="margin-top: 30px">
                      <v-flex
                        ml-8
                        my-5
                        style="text-align: left; font-weight: bold"
                      >
                        <span>Note</span>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex style="padding-left: 32px; padding-right: 32px">
                        <textarea-form
                          @update-data="updateData('noteDetail', $event)"
                          :model="form.noteDetail"
                          :rows="5"
                        ></textarea-form>
                      </v-flex>
                    </v-layout>
                    <v-layout style="margin-top: -35px">
                      <v-flex
                        ml-8
                        my-5
                        style="text-align: left; font-weight: bold"
                      >
                        <span>การตรวจสอบ</span>
                      </v-flex>
                    </v-layout>
                    <v-layout style="margin-left: 32px; margin-top: -15px">
                      <span style="font-weight: bold; padding-top: 19px"
                        >วันที่ผู้วิจัยรายงาน</span
                      >
                      <v-col cols="2" class="text-end text-field-center">
                        <DateInputForm
                          :model="researcherReportDate"
                          @update-data="
                            updateData('researcherReportDate', $event)
                          "
                          style="font-weight: bold"
                        ></DateInputForm>
                      </v-col>
                    </v-layout>

                    <v-layout mt-12>
                      <v-flex d-flex justify-start>
                        <span
                          >สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span
                        >
                      </v-flex>
                      <v-flex d-flex justify-end>
                        <span>หน้า 1 จาก 1 หน้า</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <v-layout mt-8>
                  <v-flex mb-12 style="text-align: left">
                    <v-layout>
                      <v-flex>
                        <v-btn
                          style="color: #3e7662"
                          class="mx-4"
                          depressed
                          color="#ffffff"
                          @click="$router.go(-1)"
                          >ย้อนกลับ</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex mb-12 style="text-align: right">
                    <v-layout>
                      <v-flex>
                        <v-btn
                          v-if="status == 'รอดำเนินการ'"
                          style="color: #3e7662"
                          class="mx-4"
                          depressed
                          color="#ffffff"
                          @click="saveEdit()"
                          ><v-icon>add</v-icon>บันทึกเพื่อแก้ไข</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
        </div>
        <loading
          color="#527281"
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="fullPage"
        ></loading>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import TextfieldForm from "../../../components/input/TextfieldForm";
import DateInputForm from "../../../components/input/DateInputForm";
import TextareaForm from "../../../components/input/TextareaForm";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapState } from "vuex";
import domtoimage from "dom-to-image";

export default {
  name: "FormRF06",
  components: {
    TextfieldForm,
    DateInputForm,
    TextareaForm,
    Loading,
  },
  data: () => ({
    isLoading: false,
    fullPage: true,
    form: {
      hasStartDate: false,
      fileOther: [],
      noteDetail: "",
      researcherReportDate: "",
      researchName: "",
      researchCode: "",
      researchInvestor: "",
      mainResearcher: "",
      phoneNumber: "",
      email: "",
      firstDate: new Date().toISOString().substr(0, 10),
      lastDate: new Date().toISOString().substr(0, 10),
      startDate: new Date().toISOString().substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      hasIssue: "",
      hasWarning: "",
      reason: "",
      hasFollowUp: "",
      followUp: "",
      hasPlan: "",
      plan: "",
      resultFile: "",
      instituteBook: "",
      agencyBook: "",
      bookNumber: "",
      bookDate: "",

      signature: "",
      reportDate: new Date().toISOString().substr(0, 10),
    },
    dateChange: {
      firstDate: "",
      lastDate: "",
      startDate: "",
      endDate: "",
      reportDate: "",
    },
    status: "",
    researcherReportDate: "",
    showResultFile: "",
    pathLink: "",
    agencyBook: "",
    agencyBookLink: "",
    anyProtocol: "",
    anyProtocolPath: "",
    anyComplaintFile: "",
    anyComplaintFilePath: "",
  }),
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  created() {
    console.log(this.$route.query);
    this.getRF07();
  },
  methods: {
    async printPage() {
      this.printMode = true;
      document.getElementsByClassName("print-form")[0].style.backgroundColor =
        "#fff";
      await document.querySelectorAll("button").forEach(function(element) {
        element.style.display = "none";
      });
      await document.querySelectorAll(".v-icon").forEach(function(element) {
        element.style.display = "none";
      });
      await document
        .getElementsByClassName("v-input--checkbox v-input--is-label-active")
        .forEach(function(element) {
          element.innerHTML = "✓" + element.innerHTML;
        });
      await document
        .getElementsByClassName("v-radio v-item--active")
        .forEach(function(element) {
          element.innerHTML = "✓ " + element.innerHTML;
        });
      var node = document.getElementById("print");
      var self = this;
      domtoimage
        .toPng(node)
        .then(async function(dataUrl) {
          var img = new Image();
          img.src = dataUrl;
          var page = self.imageToPrint(img);

          var pageLink = "about:blank";
          var pwa = window.open(pageLink, "_new");
          pwa.document.open();
          pwa.document.write(page);
          pwa.document.close();
          self.printMode = false;
          await document.querySelectorAll("button").forEach(function(element) {
            element.style.display = "unset";
          });
          await document
            .getElementsByClassName(
              "v-input--checkbox v-input--is-label-active"
            )
            .forEach(function(element) {
              element.innerHTML = element.innerHTML.replace("✓", "");
            });
          await document
            .getElementsByClassName("v-radio v-item--active")
            .forEach(function(element) {
              element.innerHTML = element.innerHTML.replace("✓ ", "");
            });
          await document.querySelectorAll(".v-icon").forEach(function(element) {
            element.style.display = "unset";
          });
          document
            .getElementsByClassName("print-form")[0]
            .removeAttribute("style");
        })
        .catch(function(error) {
          Swal.fire({
            title: "กรุณาเปิดการอนุญาต Pop Up!",
            description: "",
            icon: "error",
            confirmButtonColor: "#3E7662",
            cancelButtonColor: "rgb(189, 189, 189)",
            confirmButtonText: "ตกลง",
          }).then(async function() {
            await document
              .querySelectorAll("button")
              .forEach(function(element) {
                element.style.display = "unset";
              });
            await document
              .getElementsByClassName(
                "v-input--checkbox v-input--is-label-active"
              )
              .forEach(function(element) {
                element.innerHTML = element.innerHTML.replace("✓", "");
              });
            await document
              .getElementsByClassName("v-radio v-item--active")
              .forEach(function(element) {
                element.innerHTML = element.innerHTML.replace("✓ ", "");
              });
            await document
              .querySelectorAll(".v-icon")
              .forEach(function(element) {
                element.style.display = "unset";
              });
            document
              .getElementsByClassName("print-form")[0]
              .removeAttribute("style");
          });
        });
    },
    imageToPrint(source) {
      return (
        "<html><body onload='window.print()'><style>@media print {\n" +
        "  @page { margin: 0; }\n" +
        "  html, body {\n" +
        "    margin: 0;\n" +
        "    width: 210mm;\n" +
        "    height: 297mm;\n" +
        "  }\n" +
        "  img {\n" +
        "    margin-top: 10mm;\n" +
        "    margin-left: 20mm;\n" +
        "    width: 170mm;\n" +
        // "    height: 297mm;\n" +
        "  }\n" +
        "}</style>" +
        source.outerHTML +
        "</body></html>"
      );
    },
    saveEdit() {
      Swal.fire({
        title: "คุณต้องการบันทึกเพื่อแก้ไขหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึกเพื่อแก้ไข",
      }).then((result) => {
        if (result.value) {
          this.form["researchID"] = this.$route.query.id;
          this.form["rfID"] = this.$route.query.rfID;

          this.isLoading = true;
          this.$store
            .dispatch("FormRF/saveEditRF07", this.form)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกเพื่อแก้ไขสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.$router.push("/verify-rf");
              });
              console.log("res", res);

              this.isLoading = false;
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
            });
        }
      });
    },
    updateData(name, val) {
      if (name === "researcherReportDate") {
        this.researcherReportDate = this.changeDate(val.date);
        this.form.researcherReportDate = val.date;
      }
      if (name === "noteDetail") {
        this.form.noteDetail = val;
      }
    },
    open(val) {
      switch (val) {
        case "pathLink":
          window.open(this.pathLink);
          break;
        case "agencyBookLink":
          window.open(this.agencyBookLink);
          break;
        default:
          window.open(val);
          break;
      }
    },
    changeDate(val) {
      if (val != null) {
        //change date start
        let sub_year = val.substring(0, 4);
        let sub_month = val.substring(5, 7);
        let sub_day = val.substring(8, 10);
        sub_year = parseInt(sub_year) + 543;
        let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
        return changeDate;
      } else {
        return null;
      }
    },
    getRF07() {
      this.isLoading = true;
      this.$store
        .dispatch("FormRF/getRF07", this.$route.query.rfID)
        .then((res) => {
          this.form.hasStartDate = res.hasStartDate == 1;
          this.form.fileOther = res.fileOther ?? [];
          this.form.instituteBook = res.instituteBook;
          this.status = res.status;
          this.form.noteDetail = res.noteDetail;
          this.form.researcherReportDate = res.noteDetailDate;
          this.researcherReportDate = this.changeDate(res.noteDetailDate);
          this.form.researchName = res.researchName;
          this.form.researchCode = res.researchCode;
          this.form.researchInvestor = res.researchInvestor;
          this.form.mainResearcher = res.mainResearcher;
          this.form.phoneNumber = res.phoneNumber;
          this.form.email = res.email;
          this.form.firstDate = res.firstDate;
          this.dateChange.firstDate = this.changeDate(res.firstDate);
          this.form.lastDate = res.lastDate;
          this.dateChange.lastDate = this.changeDate(res.lastDate);
          this.form.startDate = res.startDate;
          this.dateChange.startDate = this.changeDate(res.startDate);
          this.form.endDate = res.endDate;
          this.dateChange.endDate = this.changeDate(res.endDate);
          this.form.hasIssue = res.hasIssue.toString();
          this.form.hasWarning = res.hasWarning.toString();
          this.pathLink = res.pathResult;
          this.form.reason = res.reason;
          this.form.hasFollowUp = res.hasFollowUp.toString();
          this.form.followUp = res.followUp;
          this.form.hasPlan = res.hasPlan.toString();
          this.form.plan = res.plan;
          this.showResultFile = res.resultFile;
          this.form.resultFile = res.resultFile;
          this.anyProtocolFilePath = res.anyProtocolFilePath;
          this.anyComplaintFilePath = res.anyComplaintFilePath;
          this.anyProtocolFile = res.anyProtocolFile;
          this.anyComplaintFile = res.anyComplaintFile;

          this.agencyBookLink = res.agencyBookPath;
          this.agencyBook = res.agencyBook;
          this.form.bookNumber = res.bookNumber;
          this.form.bookDate = !res.bookDate
            ? ""
            : this.changeDate(res.bookDate);
          this.form.accrualCeiling = res.accrualCeiling;
          this.form.totalParticipants = res.totalParticipants;
          this.form.totalScreening = res.totalScreening;
          this.form.totalWithdrawn = res.totalWithdrawn;
          this.form.totalDead = res.totalDead;
          this.form.totalCompleteResearch = res.totalCompleteResearch;
          this.form.totalExpAdversEvents = res.totalExpAdversEvents;
          this.form.totalExpSUSARs = res.totalExpSUSARs;
          this.form.totalGlobal = res.totalGlobal;

          this.form.signature = res.signature.toString();
          this.form.reportDate = res.reportDate;
          this.dateChange.reportDate = this.changeDate(res.reportDate);
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.linkPDF:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
